export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
   * `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO
   * 8601 standard for representation of dates and times using the Gregorian calendar.
   */
  DateTime: any;
};

export type Answer = {
  __typename?: 'Answer';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  option?: Maybe<Option>;
  question: Question;
  response: Response;
  updatedAt: Scalars['DateTime'];
  user: User;
  valueInt?: Maybe<Scalars['Int']>;
};

export type AnswerCount = {
  __typename?: 'AnswerCount';
  count: Scalars['Int'];
  option: Option;
};

export type AnswerListRelationFilter = {
  every?: Maybe<AnswerWhereInput>;
  none?: Maybe<AnswerWhereInput>;
  some?: Maybe<AnswerWhereInput>;
};

export type AnswerWhereInput = {
  AND?: Maybe<Array<AnswerWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  NOT?: Maybe<Array<AnswerWhereInput>>;
  option?: Maybe<OptionWhereInput>;
  optionId?: Maybe<IntNullableFilter>;
  OR?: Maybe<Array<AnswerWhereInput>>;
  question?: Maybe<QuestionWhereInput>;
  questionId?: Maybe<IntFilter>;
  response?: Maybe<ResponseWhereInput>;
  responseId?: Maybe<IntFilter>;
  tags?: Maybe<TagListRelationFilter>;
  tenant?: Maybe<TenantWhereInput>;
  tid?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserWhereInput>;
  userId?: Maybe<IntFilter>;
  valueInt?: Maybe<IntNullableFilter>;
};

export type AnswerWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type Authentication = {
  __typename?: 'Authentication';
  /** jwt token to access full api */
  token: Scalars['String'];
};

export type BoolFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolFilter>;
};

export type Case = {
  __typename?: 'Case';
  contactCount?: Maybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  logs: Array<CaseLog>;
  status: CaseStatus;
  tracing?: Maybe<Tracing>;
  user: User;
};


export type CaseLogsArgs = {
  after?: Maybe<CaseLogWhereUniqueInput>;
  before?: Maybe<CaseLogWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<CaseLogsWhereInput>;
};


export type CaseTracingArgs = {
  endTime?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
};

export type CaseCreateInput = {
  date?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

export type CaseListRelationFilter = {
  every?: Maybe<CaseWhereInput>;
  none?: Maybe<CaseWhereInput>;
  some?: Maybe<CaseWhereInput>;
};

export type CaseLog = {
  __typename?: 'CaseLog';
  createdBy: User;
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  text?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CaseLogListRelationFilter = {
  every?: Maybe<CaseLogWhereInput>;
  none?: Maybe<CaseLogWhereInput>;
  some?: Maybe<CaseLogWhereInput>;
};

export type CaseLogsWhereInput = {
  date?: Maybe<DateTimeFilter>;
  type?: Maybe<StringFilter>;
};

export type CaseLogWhereInput = {
  AND?: Maybe<Array<CaseLogWhereInput>>;
  case?: Maybe<CaseWhereInput>;
  caseId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdBy?: Maybe<UserWhereInput>;
  createdById?: Maybe<IntFilter>;
  date?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  NOT?: Maybe<Array<CaseLogWhereInput>>;
  OR?: Maybe<Array<CaseLogWhereInput>>;
  tenant?: Maybe<TenantWhereInput>;
  text?: Maybe<StringNullableFilter>;
  tid?: Maybe<IntFilter>;
  type?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CaseLogWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export enum CaseStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Sent = 'SENT'
}

export type CaseWhereInput = {
  AND?: Maybe<Array<CaseWhereInput>>;
  contactCount?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  date?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  logs?: Maybe<CaseLogListRelationFilter>;
  NOT?: Maybe<Array<CaseWhereInput>>;
  OR?: Maybe<Array<CaseWhereInput>>;
  status?: Maybe<CaseStatus>;
  tenant?: Maybe<TenantWhereInput>;
  tid?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserWhereInput>;
  userId?: Maybe<IntFilter>;
};

export type CaseWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type Chart = {
  __typename?: 'Chart';
  /** Average number of contacts per case. */
  averageContactsPerCase: Scalars['Int'];
  /** Average team comfort level in given time period among all active users */
  averageTeamComfort: Scalars['Int'];
  /** Get count of checkins between dates */
  checkinCount: Scalars['Int'];
  /** Get count of checkins between dates grouped by day */
  checkinCountByDay: Array<CheckinCountByDay>;
  /** Get count of checkins between dates grouped by space */
  checkinCountBySpace: Array<CheckinCountBySpace>;
  /** Get count of all active users who have completed 1+ surveys in the given time period */
  completedSurveyCount: Scalars['Int'];
  /** Average usage by time of day (filterable by space) */
  hourlyUse: Array<HourlyUsage>;
  /** Count all of all created contact tracing cases grouped by day. */
  newCasesCountByDay: Array<NewCasesCountByDay>;
  /** Get count of all active users whose most recent symptoms report was 'no symptoms' in the given time period */
  noSymptomsCount: Scalars['Int'];
  /** Count all of all open contact tracing cases. */
  openCasesCount: Scalars['Int'];
  /** Get count of all active users who have reported 1+ symptoms in the given time period */
  reportedSymptomsCount: Scalars['Int'];
  /** Get count of all active users as of given date */
  userCount: Scalars['Int'];
};


export type ChartAverageTeamComfortArgs = {
  filters: ChartFilter;
};


export type ChartCheckinCountArgs = {
  filters: ChartFilter;
};


export type ChartCheckinCountByDayArgs = {
  filters: ChartFilter;
};


export type ChartCheckinCountBySpaceArgs = {
  filters: ChartFilter;
  limit?: Maybe<Scalars['Int']>;
};


export type ChartCompletedSurveyCountArgs = {
  filters: ChartFilter;
};


export type ChartHourlyUseArgs = {
  filters: ChartFilter;
  spaceId?: Maybe<Scalars['Int']>;
};


export type ChartNewCasesCountByDayArgs = {
  filters: ChartFilter;
};


export type ChartNoSymptomsCountArgs = {
  filters: ChartFilter;
};


export type ChartReportedSymptomsCountArgs = {
  filters: ChartFilter;
};


export type ChartUserCountArgs = {
  filters?: Maybe<UserCountQueryFilters>;
};

export type ChartFilter = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type CheckinCountByDay = {
  __typename?: 'CheckinCountByDay';
  count: Scalars['Int'];
  date: Scalars['DateTime'];
};

export type CheckinCountBySpace = {
  __typename?: 'CheckinCountBySpace';
  count: Scalars['Int'];
  space: Space;
};

export type CheckinSession = {
  __typename?: 'CheckinSession';
  endTime: Scalars['DateTime'];
  id: Scalars['String'];
  space: Space;
  startTime: Scalars['DateTime'];
  userCount: Scalars['Int'];
};

export type CreateNoteInput = {
  caseId?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
};

export type CreateSurveyResponseInput = {
  answers?: Maybe<Array<SurveyAnswerInput>>;
  space?: Maybe<Scalars['Int']>;
  surveyId?: Maybe<Scalars['String']>;
};

export type CreateTenantInput = {
  domains?: Maybe<Array<Scalars['String']>>;
  initialAdminEmails?: Maybe<Array<Scalars['String']>>;
  locations?: Maybe<Array<LocationInput>>;
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type DateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type Domain = {
  __typename?: 'Domain';
  id: Scalars['Int'];
  root: Scalars['String'];
};

export type DomainListRelationFilter = {
  every?: Maybe<DomainWhereInput>;
  none?: Maybe<DomainWhereInput>;
  some?: Maybe<DomainWhereInput>;
};

export type DomainWhereInput = {
  AND?: Maybe<Array<DomainWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  NOT?: Maybe<Array<DomainWhereInput>>;
  OR?: Maybe<Array<DomainWhereInput>>;
  root?: Maybe<StringFilter>;
  tenant?: Maybe<TenantWhereInput>;
  tid?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailTidCompoundUniqueInput = {
  email: Scalars['String'];
  tid: Scalars['Int'];
};

export type Exposure = {
  __typename?: 'Exposure';
  checkinSession: CheckinSession;
  exposedUser: User;
};

export type HourlyUsage = {
  __typename?: 'HourlyUsage';
  count: Scalars['Int'];
  hour: Scalars['Int'];
};

export type IntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type LocationInput = {
  slug: Scalars['String'];
  text: Scalars['String'];
};

export type LocationUniqueFindInput = {
  slug: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Exchange auth.birdlevel.com JWT for an api access JWT */
  acceptGDPR?: Maybe<Scalars['Boolean']>;
  /** Allows admins who run multiple organizations to login to their tenants */
  assumeTenant?: Maybe<Authentication>;
  /** Exchange auth.birdlevel.com JWT for an api access JWT */
  authorize?: Maybe<Authentication>;
  /** Add a note to a case */
  createCaseNote: CaseLog;
  /** Create a new contact tracing case */
  createOneCase: Case;
  createOneSpace: Space;
  /** Create a survey response for a user */
  createSurveyResponse: Response;
  /** Create a new tenant (requires super-admin) */
  createTenant?: Maybe<Tenant>;
  /** Recreate dummy data in the demo account */
  regenerateDummyData?: Maybe<Scalars['Boolean']>;
  /** Toggle whether or not a user is an admin */
  setAdmin?: Maybe<User>;
  /** Signup a new tenant */
  signup?: Maybe<SignupMutationResponse>;
  /** Update a case */
  updateCase?: Maybe<Case>;
  updateSpace?: Maybe<Space>;
};


export type MutationAssumeTenantArgs = {
  slug: Scalars['String'];
};


export type MutationAuthorizeArgs = {
  jwt: Scalars['String'];
  tenant?: Maybe<Scalars['String']>;
};


export type MutationCreateCaseNoteArgs = {
  input?: Maybe<CreateNoteInput>;
};


export type MutationCreateOneCaseArgs = {
  input?: Maybe<CaseCreateInput>;
};


export type MutationCreateOneSpaceArgs = {
  input?: Maybe<SpaceCreateInput>;
};


export type MutationCreateSurveyResponseArgs = {
  input?: Maybe<CreateSurveyResponseInput>;
};


export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};


export type MutationSetAdminArgs = {
  input: SetAdminInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
  jwt: Scalars['String'];
};


export type MutationUpdateCaseArgs = {
  input?: Maybe<UpdateCaseInput>;
};


export type MutationUpdateSpaceArgs = {
  input?: Maybe<UpdateSpaceInput>;
};

export type NestedBoolFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolFilter>;
};

export type NestedDateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedIntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringNullableFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NewCasesCountByDay = {
  __typename?: 'NewCasesCountByDay';
  count: Scalars['Int'];
  date: Scalars['DateTime'];
};

export type Option = {
  __typename?: 'Option';
  active: Scalars['Boolean'];
  id: Scalars['Int'];
  mutex: Scalars['Boolean'];
  order: Scalars['Int'];
  question: Question;
  slug?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  valueInt?: Maybe<Scalars['Int']>;
};

export type OptionListRelationFilter = {
  every?: Maybe<OptionWhereInput>;
  none?: Maybe<OptionWhereInput>;
  some?: Maybe<OptionWhereInput>;
};

export type OptionWhereInput = {
  active?: Maybe<BoolFilter>;
  AND?: Maybe<Array<OptionWhereInput>>;
  Answer?: Maybe<AnswerListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  mutex?: Maybe<BoolFilter>;
  NOT?: Maybe<Array<OptionWhereInput>>;
  OR?: Maybe<Array<OptionWhereInput>>;
  order?: Maybe<IntFilter>;
  question?: Maybe<QuestionWhereInput>;
  questionId?: Maybe<IntFilter>;
  slug?: Maybe<StringNullableFilter>;
  tenant?: Maybe<TenantWhereInput>;
  text?: Maybe<StringFilter>;
  tid?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  valueInt?: Maybe<IntNullableFilter>;
};

export type OptionWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
  slug_questionId_tid?: Maybe<SlugQuestionIdTidCompoundUniqueInput>;
};

export type Query = {
  __typename?: 'Query';
  cases: Array<Case>;
  chart: Chart;
  locations: Array<Tag>;
  /** Get current user */
  me?: Maybe<User>;
  /** qcs */
  qcs: Scalars['String'];
  /** Get a question by slug */
  questionBySlug: Question;
  /** Get all questions with the given tag */
  questionsByTag: Array<Question>;
  spaces: Array<Space>;
  /** Generate a survey given the parameters */
  survey: Survey;
  /** Get all users for tenant */
  users: Array<User>;
};


export type QueryCasesArgs = {
  after?: Maybe<CaseWhereUniqueInput>;
  before?: Maybe<CaseWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<QueryCasesOrderByInput>>;
  where?: Maybe<QueryCasesWhereInput>;
};


export type QueryLocationsArgs = {
  after?: Maybe<TagWhereUniqueInput>;
  before?: Maybe<TagWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<QueryTagsWhereInput>;
};


export type QueryQuestionBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryQuestionsByTagArgs = {
  tag: Scalars['String'];
};


export type QuerySpacesArgs = {
  after?: Maybe<SpaceWhereUniqueInput>;
  before?: Maybe<SpaceWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<QuerySpacesWhereInput>;
};


export type QuerySurveyArgs = {
  all?: Maybe<Array<Scalars['String']>>;
  any?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['String']>;
};


export type QueryUsersArgs = {
  search?: Maybe<Scalars['String']>;
};

export type QueryCasesOrderByInput = {
  date?: Maybe<SortOrder>;
};

export type QueryCasesWhereInput = {
  id?: Maybe<IntFilter>;
  status?: Maybe<CaseStatus>;
};

export type QuerySpacesWhereInput = {
  active?: Maybe<BoolFilter>;
  id?: Maybe<IntFilter>;
};

export type QueryTagsWhereInput = {
  slug?: Maybe<StringFilter>;
  text?: Maybe<StringNullableFilter>;
};

export type Question = {
  __typename?: 'Question';
  active: Scalars['Boolean'];
  answerCounts: Array<AnswerCount>;
  answers: Array<Answer>;
  average: Scalars['Float'];
  id: Scalars['Int'];
  /** Most recent response from each respondent with every option they chose */
  mostRecentResponses: Array<UserAnswers>;
  options: Array<Option>;
  order?: Maybe<Scalars['Int']>;
  /**
   * Gets the total number of respondents and count by option in the given time
   * period; counts each user's most recent response (in the time period) only.
   */
  respondentCounts: RespondentCounts;
  slug?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};


export type QuestionAnswerCountsArgs = {
  filters: ChartFilter;
};


export type QuestionAnswersArgs = {
  after?: Maybe<AnswerWhereUniqueInput>;
  before?: Maybe<AnswerWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuestionAverageArgs = {
  filters: ChartFilter;
};


export type QuestionMostRecentResponsesArgs = {
  filters: ChartFilter;
};


export type QuestionOptionsArgs = {
  after?: Maybe<OptionWhereUniqueInput>;
  before?: Maybe<OptionWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuestionRespondentCountsArgs = {
  filters: ChartFilter;
};

export type QuestionListRelationFilter = {
  every?: Maybe<QuestionWhereInput>;
  none?: Maybe<QuestionWhereInput>;
  some?: Maybe<QuestionWhereInput>;
};

export type QuestionWhereInput = {
  AND?: Maybe<Array<QuestionWhereInput>>;
  answers?: Maybe<AnswerListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  NOT?: Maybe<Array<QuestionWhereInput>>;
  options?: Maybe<OptionListRelationFilter>;
  OR?: Maybe<Array<QuestionWhereInput>>;
  Response?: Maybe<ResponseWhereInput>;
  responseId?: Maybe<IntNullableFilter>;
  slug?: Maybe<StringNullableFilter>;
  tags?: Maybe<TagQuestionListRelationFilter>;
  tenant?: Maybe<TenantWhereInput>;
  text?: Maybe<StringFilter>;
  tid?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type RespondentCount = {
  __typename?: 'RespondentCount';
  option: Option;
  respondents: Scalars['Int'];
};

export type RespondentCounts = {
  __typename?: 'RespondentCounts';
  respondentCounts: Array<RespondentCount>;
  totalRespondents: Scalars['Int'];
};

export type Response = {
  __typename?: 'Response';
  answers: Array<Answer>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  tags: Array<Tag>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['Int'];
};


export type ResponseAnswersArgs = {
  after?: Maybe<AnswerWhereUniqueInput>;
  before?: Maybe<AnswerWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ResponseTagsArgs = {
  after?: Maybe<TagWhereUniqueInput>;
  before?: Maybe<TagWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ResponseListRelationFilter = {
  every?: Maybe<ResponseWhereInput>;
  none?: Maybe<ResponseWhereInput>;
  some?: Maybe<ResponseWhereInput>;
};

export type ResponseWhereInput = {
  AND?: Maybe<Array<ResponseWhereInput>>;
  answers?: Maybe<AnswerListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  NOT?: Maybe<Array<ResponseWhereInput>>;
  OR?: Maybe<Array<ResponseWhereInput>>;
  questions?: Maybe<QuestionListRelationFilter>;
  spaces?: Maybe<SpaceListRelationFilter>;
  tags?: Maybe<TagListRelationFilter>;
  tenant?: Maybe<TenantWhereInput>;
  tid?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserWhereInput>;
  userId?: Maybe<IntFilter>;
};

export type ResponseWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type SetAdminInput = {
  email: Scalars['String'];
  isAdmin: Scalars['Boolean'];
};

export type SignupInput = {
  location?: Maybe<LocationInput>;
  name?: Maybe<Scalars['String']>;
  space?: Maybe<SpaceCreateInput>;
};

export type SignupMutationResponse = {
  __typename?: 'SignupMutationResponse';
  space: Space;
  tenant: Tenant;
};

export type SlugQuestionIdTidCompoundUniqueInput = {
  questionId: Scalars['Int'];
  slug: Scalars['String'];
  tid: Scalars['Int'];
};

export type SlugTidCompoundUniqueInput = {
  slug: Scalars['String'];
  tid: Scalars['Int'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Space = {
  __typename?: 'Space';
  active: Scalars['Boolean'];
  capacity?: Maybe<Scalars['Int']>;
  checkins: Array<Response>;
  checkinSessions: Array<CheckinSession>;
  id: Scalars['Int'];
  location: Tag;
  name: Scalars['String'];
};


export type SpaceCheckinsArgs = {
  endTime?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
};


export type SpaceCheckinSessionsArgs = {
  endTime?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
};

export type SpaceCreateInput = {
  capacity?: Maybe<Scalars['Int']>;
  location: LocationUniqueFindInput;
  name?: Maybe<Scalars['String']>;
};

export type SpaceListRelationFilter = {
  every?: Maybe<SpaceWhereInput>;
  none?: Maybe<SpaceWhereInput>;
  some?: Maybe<SpaceWhereInput>;
};

export type SpaceWhereInput = {
  active?: Maybe<BoolFilter>;
  AND?: Maybe<Array<SpaceWhereInput>>;
  capacity?: Maybe<IntNullableFilter>;
  checkins?: Maybe<ResponseListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  location?: Maybe<TagWhereInput>;
  locationId?: Maybe<IntFilter>;
  name?: Maybe<StringFilter>;
  NOT?: Maybe<Array<SpaceWhereInput>>;
  OR?: Maybe<Array<SpaceWhereInput>>;
  tags?: Maybe<TagListRelationFilter>;
  tenant?: Maybe<TenantWhereInput>;
  tid?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SpaceWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type StringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringNullableFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type Survey = {
  __typename?: 'Survey';
  id: Scalars['String'];
  questions: Array<Question>;
};

export type SurveyAnswerInput = {
  optionId?: Maybe<Scalars['Int']>;
  questionId?: Maybe<Scalars['Int']>;
};

export type Tag = {
  __typename?: 'Tag';
  active: Scalars['Boolean'];
  id: Scalars['Int'];
  responses: Array<Response>;
  slug: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


export type TagResponsesArgs = {
  after?: Maybe<ResponseWhereUniqueInput>;
  before?: Maybe<ResponseWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<TagResponsesWhereInput>;
};

export type TagListRelationFilter = {
  every?: Maybe<TagWhereInput>;
  none?: Maybe<TagWhereInput>;
  some?: Maybe<TagWhereInput>;
};

export type TagQuestionListRelationFilter = {
  every?: Maybe<TagQuestionWhereInput>;
  none?: Maybe<TagQuestionWhereInput>;
  some?: Maybe<TagQuestionWhereInput>;
};

export type TagQuestionWhereInput = {
  active?: Maybe<BoolFilter>;
  AND?: Maybe<Array<TagQuestionWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  NOT?: Maybe<Array<TagQuestionWhereInput>>;
  OR?: Maybe<Array<TagQuestionWhereInput>>;
  order?: Maybe<IntFilter>;
  question?: Maybe<QuestionWhereInput>;
  questionId?: Maybe<IntFilter>;
  tag?: Maybe<TagWhereInput>;
  tagId?: Maybe<IntFilter>;
  tenant?: Maybe<TenantWhereInput>;
  tid?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TagResponsesWhereInput = {
  createdAt?: Maybe<DateTimeFilter>;
  tags?: Maybe<TagListRelationFilter>;
};

export type TagWhereInput = {
  active?: Maybe<BoolFilter>;
  AND?: Maybe<Array<TagWhereInput>>;
  answers?: Maybe<AnswerListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  NOT?: Maybe<Array<TagWhereInput>>;
  OR?: Maybe<Array<TagWhereInput>>;
  questions?: Maybe<TagQuestionListRelationFilter>;
  responses?: Maybe<ResponseListRelationFilter>;
  slug?: Maybe<StringFilter>;
  Space?: Maybe<SpaceListRelationFilter>;
  spaces?: Maybe<SpaceListRelationFilter>;
  tenant?: Maybe<TenantWhereInput>;
  text?: Maybe<StringNullableFilter>;
  tid?: Maybe<IntFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  users?: Maybe<UserListRelationFilter>;
};

export type TagWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
  slug_tid?: Maybe<SlugTidCompoundUniqueInput>;
};

export type Tenant = {
  __typename?: 'Tenant';
  flags: Array<TenantFlag>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  users: Array<User>;
};


export type TenantFlagsArgs = {
  after?: Maybe<TenantFlagWhereUniqueInput>;
  before?: Maybe<TenantFlagWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type TenantUsersArgs = {
  after?: Maybe<UserWhereUniqueInput>;
  before?: Maybe<UserWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type TenantFlag = {
  __typename?: 'TenantFlag';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type TenantFlagListRelationFilter = {
  every?: Maybe<TenantFlagWhereInput>;
  none?: Maybe<TenantFlagWhereInput>;
  some?: Maybe<TenantFlagWhereInput>;
};

export type TenantFlagWhereInput = {
  AND?: Maybe<Array<TenantFlagWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  key?: Maybe<StringFilter>;
  NOT?: Maybe<Array<TenantFlagWhereInput>>;
  OR?: Maybe<Array<TenantFlagWhereInput>>;
  tenant?: Maybe<TenantWhereInput>;
  tid?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  value?: Maybe<StringFilter>;
};

export type TenantFlagWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type TenantWhereInput = {
  active?: Maybe<BoolFilter>;
  AND?: Maybe<Array<TenantWhereInput>>;
  answers?: Maybe<AnswerListRelationFilter>;
  Case?: Maybe<CaseListRelationFilter>;
  CaseLog?: Maybe<CaseLogListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  domains?: Maybe<DomainListRelationFilter>;
  flags?: Maybe<TenantFlagListRelationFilter>;
  id?: Maybe<IntFilter>;
  name?: Maybe<StringNullableFilter>;
  NOT?: Maybe<Array<TenantWhereInput>>;
  Option?: Maybe<OptionListRelationFilter>;
  OR?: Maybe<Array<TenantWhereInput>>;
  questions?: Maybe<QuestionListRelationFilter>;
  responses?: Maybe<ResponseListRelationFilter>;
  slug?: Maybe<StringFilter>;
  spaces?: Maybe<SpaceListRelationFilter>;
  TagQuestion?: Maybe<TagQuestionListRelationFilter>;
  tags?: Maybe<TagListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  users?: Maybe<UserListRelationFilter>;
};

export type Tracing = {
  __typename?: 'Tracing';
  checkinSessions: Array<CheckinSession>;
  endTime: Scalars['DateTime'];
  exposures: Array<Exposure>;
  startTime: Scalars['DateTime'];
  users: Array<User>;
};

export type UpdateCaseInput = {
  id: Scalars['Int'];
  status?: Maybe<CaseStatus>;
};

export type UpdateSpaceInput = {
  active?: Maybe<Scalars['Boolean']>;
  capacity?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  answers: Array<Answer>;
  email: Scalars['String'];
  gdpr?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  responses: Array<Response>;
  survey: Survey;
  tags: Array<Tag>;
  tenant: Tenant;
};


export type UserAnswersArgs = {
  after?: Maybe<AnswerWhereUniqueInput>;
  before?: Maybe<AnswerWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserResponsesArgs = {
  after?: Maybe<ResponseWhereUniqueInput>;
  before?: Maybe<ResponseWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserTagsArgs = {
  after?: Maybe<TagWhereUniqueInput>;
  before?: Maybe<TagWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<UserTagsWhereInput>;
};

export type UserAnswers = {
  __typename?: 'UserAnswers';
  answers: Array<Answer>;
  user: User;
};

export type UserCountQueryFilters = {
  asOf: Scalars['DateTime'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type UserListRelationFilter = {
  every?: Maybe<UserWhereInput>;
  none?: Maybe<UserWhereInput>;
  some?: Maybe<UserWhereInput>;
};

export type UserTagsWhereInput = {
  type?: Maybe<StringNullableFilter>;
};

export type UserWhereInput = {
  active?: Maybe<BoolFilter>;
  AND?: Maybe<Array<UserWhereInput>>;
  answers?: Maybe<AnswerListRelationFilter>;
  CaseLog?: Maybe<CaseLogListRelationFilter>;
  cases?: Maybe<CaseListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  gdpr?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IntFilter>;
  name?: Maybe<StringNullableFilter>;
  NOT?: Maybe<Array<UserWhereInput>>;
  OR?: Maybe<Array<UserWhereInput>>;
  responses?: Maybe<ResponseListRelationFilter>;
  tags?: Maybe<TagListRelationFilter>;
  tenant?: Maybe<TenantWhereInput>;
  tid?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type UserWhereUniqueInput = {
  email_tid?: Maybe<EmailTidCompoundUniqueInput>;
  id?: Maybe<Scalars['Int']>;
};
